export const positionsNames = {
    SUPERADMIN: 'Super administrador',
    ADMIN: 'Administrador',
    SUPERVISOR: 'Referente',
    FAMILIA: 'Familia',
    LABORATORIO: 'Laboratorista',
    USUARIO: 'Usuario panel',
    AGENTE: 'Agente sanitario'
}